import type { NDateLocale } from './enUS'
import { ptBR } from 'date-fns/locale'

const datePtBr: NDateLocale = {
  name: 'pt-BR',
  locale: ptBR
}

export default datePtBr
